<template>
    <div class="page-content">
        <h2> Simulator - Manage your saved filters </h2>
        <div class="form-content">
            <table class="table table-striped table-bordered" v-if="filterSetList && filterSetList.length >0">
                <thead style="text-align:center;font-weight:bold;"> <tr><td>Name</td> <td>Created</td> <td>Updated</td> <td>Action</td></tr> </thead>
                <tbody>
                    <tr v-for="(filter, index) in filterSetList" :key="index">
                        <td>{{filter.name }}</td>
                        <td>{{ formatDate( filter.created) }}</td>
                        <td>{{ formatDate(filter.updated) }}</td>
                        <td>
                            <router-link class="button button-primary" :to="`/simulator/${filter.ID}`">View</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="row" v-if="filterSetList.length <1" style="padding-bottom:30px;"> You have no saved filters to display. </div>
            <div class="row">
                <router-link class="button button-primary" to="/simulator">Return to Simulator</router-link>
            </div>
        </div>
        <br />
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        computed: {
            ...mapGetters(['filterSetList']),
        },
        async created() {
            let oktaToken = await this.$auth.getAccessToken();
            await this.GetFilterSet(oktaToken);
        },
        methods: {
            ...mapActions(['GetFilterSet']),
            formatDate(dateString) {
                var dateStr = new Date(dateString)
                return dateStr.toLocaleString('en-GB');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @use 'sass:math';
    @import '../../styles/base';
    @import '../../../node_modules/hd-styles/modules/mixins';
    $border: $border-width-light solid $grey;

    .row {
        display: inline-flex;
        width: 100%;
    }

    .column {
        width: 50%;
        margin-bottom: 0;
        font-weight: 600;
    }

    table {
        width: 50%;
        border-radius: $border-radius-large;
        border: $border;
        border-spacing: 0;
        overflow: hidden;
        margin-bottom: $spacing-unit;
    }

    td, th {
        padding: math.div($spacing-unit, 2);
        border-right: $border;

        &:last-child {
            border-right: none;
        }
    }

    tr:nth-child(2n), thead tr {
        background-color: $grey-blue;
    }
   

    h2{
        color:black;
        font-weight:bold;
    }

</style>
